import { Link } from "react-router-dom";

/**
 * Operational Status Rail — a reusable digital "operations board" strip,
 * inspired by airport/DMV information displays. Segments act as filters:
 * each shows a name, a digital-style count, and an active/selected state.
 *
 * Live-state signalling (restrained; movement = "active work is waiting"):
 *   - item.live + item.liveKind === "breathing": the active segment softly
 *     breathes (used for Interview Waiting).
 *   - item.live + item.liveKind === "dot": a small pulsing dot appears
 *     (used for Review Availability). Disappears when the count is zero.
 * Reusable across MIHP wherever segmented operational counts appear.
 */
export function OperationalStatusRail({ items, activeKey, getHref, label = "Filter by segment", testid = "operational-status-rail" }) {
  const digits = (n) => String(n).padStart(2, "0");
  return (
    <div>
      {label && <div className="op-rail-head">{label}</div>}
      <div className="op-rail" role="tablist" data-testid={testid}>
        {items.map((it) => {
          const isActive = activeKey === it.key;
          const breathing = isActive && it.live && it.liveKind === "breathing";
          const dot = it.live && it.liveKind === "dot";
          return (
            <Link
              key={it.key}
              to={getHref(it.key)}
              role="tab"
              aria-selected={isActive}
              className={`op-seg${isActive ? " on" : ""}${breathing ? " breathing" : ""}`}
              data-testid={`segment-${it.key}`}
            >
              {dot && <span className="live-dot" data-testid={`segment-live-${it.key}`} aria-hidden="true" />}
              <span className="op-name">{it.label}</span>
              <span className="op-count">{digits(it.count)}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
